import {Injectable} from '@angular/core';
import {ApiResponse} from 'src/interfaces/apiresponse.interface';
import {AuditorDTO} from 'src/interfaces/auditorDTO.interface';
import { HttpClient, HttpResponse } from '@angular/common/http';
import Helpers from 'src/shared/helpers';
import { firstValueFrom } from 'rxjs';
import { API_BASE_URI } from 'src/shared/constants';

@Injectable()
export class LogService {
    constructor(private http: HttpClient) { }

    public async getLogEntries(): Promise<HttpResponse<ApiResponse>> {
        const url = API_BASE_URI + '/api/log/run/recent';

        return await firstValueFrom(this.http.get<HttpResponse<ApiResponse>>(url, <Object>Helpers.getDefaultHttpOptions()));
    }

    public async logRun(auditData: AuditorDTO): Promise<boolean> {
        const url = API_BASE_URI + '/api/log/run/add';

        return await firstValueFrom(this.http.post<boolean>(url, auditData, <Object>Helpers.getDefaultHttpOptions()));
    }
}
